export interface BitcoinPrice {
  btcusd: number;
  satsPerDollar: number;
}

export async function fetchBitcoinPrice(): Promise<BitcoinPrice> {
  try {
    const response = await fetch('https://api.coinbase.com/v2/exchange-rates?currency=BTC');
    const data = await response.json();
    const btcusd = parseFloat(data.data.rates.USD);
    const satsPerDollar = Math.floor(100000000 / btcusd);
    
    return {
      btcusd,
      satsPerDollar
    };
  } catch (error) {
    console.error('Failed to fetch Bitcoin price:', error);
    // Fallback price if API fails
    return {
      btcusd: 90000,
      satsPerDollar: 1111
    };
  }
}

export function usdToSats(usd: number, satsPerDollar: number): number {
  return Math.floor(usd * satsPerDollar);
}

export function formatSats(sats: number): string {
  return new Intl.NumberFormat('en-US').format(sats);
}